import React, { useState, useEffect } from "react";
import data from "../Data.json";

const Feat = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        setProducts(data.featured);
    }, []);

    const nextProducts = () => {
        setCurrentIndex((prevIndex) =>
            (prevIndex + 1) % Math.ceil(products.length / 4)
        );
    };

    const prevProducts = () => {
        setCurrentIndex((prevIndex) =>
            (prevIndex - 1 + Math.ceil(products.length / 4)) % Math.ceil(products.length / 4)
        );
    };

    const visibleProducts = products.slice(currentIndex * 4, currentIndex * 4 + 4);

    return (
        <div className="flex flex-col items-center px-4">
            <h1 className="text-3xl font-bold mb-2">Featured Collection</h1>

            {/* Categories Text */}
            <div className="mb-4 flex space-x-4">
                <span className="font-semibold text-lg">New Arrivals</span>
                <span className="font-semibold text-lg">Featured</span>
                <span className="font-semibold text-lg">Best Seller</span>
            </div>

            {/* Product Grid */}
            <div className="flex items-center w-full space-x-4">
                <button
                    className="bg-gray-300 p-2 rounded-full"
                    onClick={prevProducts}
                >
                    &lt;
                </button>
                <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {visibleProducts.map((product, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center space-y-2 bg-white shadow rounded-lg p-4"
                        >
                            <img
                                src={product.image}
                                alt={product.name}
                                className="h-48 w-full object-cover rounded"
                            />
                            <h2 className="font-semibold text-center">
                                {product.name}
                            </h2>
                            <p className="text-lg text-center">
                                {product.price}
                                {product.originalPrice && (
                                    <span className="line-through text-red-500 ml-2">
                                        {product.originalPrice}
                                    </span>
                                )}
                            </p>
                        </div>
                    ))}
                </div>
                <button
                    className="bg-gray-300 p-2 rounded-full"
                    onClick={nextProducts}
                >
                    &gt;
                </button>
            </div>
        </div>
    );
};

export default Feat;
